// The Capacity guide (34_Capacity.jsx · ModuleHelp, Max 01/11).
const en = {
  tabsT: 'Two views',
  tabsB: 'Lines lists the PO lines and the hours behind them. Load vs capacity sets the hours these orders need against the hours each vendor has.',
  statsT: 'The totals',
  statsB: 'Lines, quantity and hours for what the filters below leave on screen: ordered, done and still remaining.',
  filtersT: 'Narrow the list',
  filtersB: 'Pick a vendor, delivery months, a cycle or open/finished lines, or type to search. Clear puts every filter back.',
  colsT: 'Columns and reload',
  colsB: 'Columns chooses which columns show and how many stay pinned on the left. Reload reads the lines again.',
  tableT: 'The lines',
  tableB: 'One row per PO line. Click a header to sort or filter it; the table scrolls sideways and keeps the first columns in view.',
  editT: 'Edit a line',
  editB: 'If you may edit capacity, the pencil opens the typed fields of that row in place. Save with Enter, cancel with Esc.',
};
const ko = {
  tabsT: '두 가지 보기',
  tabsB: 'Lines는 PO 라인과 그 공수를 보여 줍니다. Load vs capacity는 이 주문에 필요한 시간과 업체가 가진 시간을 비교합니다.',
  statsT: '합계',
  statsB: '아래 필터로 화면에 남은 항목의 라인 수, 수량, 시간(주문·완료·잔여)입니다.',
  filtersT: '목록 좁히기',
  filtersB: '업체, 납기 월, 사이클, 진행 중/완료 라인을 고르거나 검색어를 입력하세요. 지우기를 누르면 모든 필터가 초기화됩니다.',
  colsT: '열과 새로고침',
  colsB: '열에서 표시할 열과 왼쪽에 고정할 열 수를 정합니다. 새로고침은 라인을 다시 읽어 옵니다.',
  tableT: '라인 목록',
  tableB: 'PO 라인당 한 행입니다. 머리글을 클릭해 정렬·필터하고, 표는 가로로 스크롤되며 앞쪽 열은 고정됩니다.',
  editT: '라인 수정',
  editB: '용량 수정 권한이 있으면 연필 버튼으로 해당 행의 입력 가능 필드를 바로 수정합니다. Enter로 저장, Esc로 취소합니다.',
};
const vi = {
  tabsT: 'Hai chế độ xem',
  tabsB: 'Lines liệt kê các dòng PO và số giờ tương ứng. Load vs capacity so số giờ các đơn này cần với số giờ mỗi vendor có.',
  statsT: 'Số tổng',
  statsB: 'Số dòng, số lượng và số giờ của phần còn hiện sau khi lọc bên dưới: đã đặt, đã xong và còn lại.',
  filtersT: 'Thu hẹp danh sách',
  filtersB: 'Chọn vendor, tháng giao, cycle hoặc dòng đang mở/đã xong, hay gõ để tìm. Nút xóa đưa mọi bộ lọc về ban đầu.',
  colsT: 'Cột và tải lại',
  colsB: 'Cột để chọn cột hiển thị và số cột ghim bên trái. Tải lại đọc lại các dòng.',
  tableT: 'Các dòng',
  tableB: 'Mỗi dòng PO một hàng. Bấm tiêu đề cột để sắp xếp hoặc lọc; bảng cuộn ngang và giữ các cột đầu luôn thấy.',
  editT: 'Sửa một dòng',
  editB: 'Nếu bạn có quyền sửa capacity, nút bút chì mở các ô được nhập tay của dòng đó ngay tại chỗ. Enter để lưu, Esc để hủy.',
};
const zh = {
  tabsT: '两种视图',
  tabsB: 'Lines 列出 PO 行及对应工时。Load vs capacity 对比这些订单所需工时与各供应商可用工时。',
  statsT: '合计',
  statsB: '按下方筛选后留在屏幕上的行数、数量和工时：订单工时、已完成、剩余。',
  filtersT: '缩小列表范围',
  filtersB: '选择供应商、交期月份、周期或未完成/已完成的行，也可以输入关键字搜索。点清除可恢复所有筛选。',
  colsT: '列与刷新',
  colsB: '“列”用于选择显示哪些列以及左侧固定几列。刷新会重新读取数据行。',
  tableT: '数据行',
  tableB: '每条 PO 行一行。点击表头可排序或筛选；表格可左右滚动，前几列保持固定。',
  editT: '编辑一行',
  editB: '如果你有编辑产能的权限，点铅笔图标可直接修改该行可手工填写的字段。按 Enter 保存，按 Esc 取消。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "tabsT": "Deux vues",
  "tabsB": "Lignes liste les lignes de PO et les heures correspondantes. Charge vs capacité compare les heures nécessaires à ces commandes aux heures dont dispose chaque fournisseur.",
  "statsT": "Les totaux",
  "statsB": "Lignes, quantité et heures pour ce que les filtres ci-dessous laissent à l'écran : commandé, réalisé et restant.",
  "filtersT": "Affiner la liste",
  "filtersB": "Choisissez un fournisseur, des mois de livraison, un cycle ou les lignes ouvertes/terminées, ou saisissez du texte pour rechercher. Effacer remet tous les filtres.",
  "colsT": "Colonnes et rechargement",
  "colsB": "Colonnes permet de choisir les colonnes affichées et le nombre de colonnes épinglées à gauche. Recharger relit les lignes.",
  "tableT": "Les lignes",
  "tableB": "Une ligne par ligne de PO. Cliquez sur un en-tête pour trier ou filtrer ; le tableau défile horizontalement et garde les premières colonnes visibles.",
  "editT": "Modifier une ligne",
  "editB": "Si vous avez le droit de modifier la capacité, le crayon ouvre sur place les champs de saisie de cette ligne. Enregistrez avec Entrée, annulez avec Échap."
};
const ja = {
  "tabsT": "2つのビュー",
  "tabsB": "「明細」は PO 明細とその工数を一覧表示します。「負荷とキャパシティ」は、これらの注文に必要な工数と各仕入先の保有工数を比較します。",
  "statsT": "合計",
  "statsB": "下のフィルターで画面に残っている分の明細数、数量、工数：発注済み、完了、残りです。",
  "filtersT": "リストを絞り込む",
  "filtersB": "仕入先、納期月、サイクル、未完了/完了の明細を選ぶか、文字を入力して検索します。「クリア」ですべてのフィルターが元に戻ります。",
  "colsT": "列と再読み込み",
  "colsB": "「列」で表示する列と、左に固定する列数を選びます。「再読み込み」で明細を読み込み直します。",
  "tableT": "明細",
  "tableB": "PO 明細ごとに1行です。見出しをクリックすると並べ替えや絞り込みができます。表は横にスクロールし、最初の列は表示されたままです。",
  "editT": "明細を編集",
  "editB": "キャパシティを編集する権限がある場合、ペンのアイコンでその行の入力欄がその場で開きます。Enter で保存、Esc でキャンセルします。"
};

const dictionary = { ns: 'tourCapacity', en, ko, vi, zh, fr, ja };
export default dictionary;
